var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"w-full flex flex-row items-center font-semibold text-base lg:text-xl mb-3",class:[_vm.isPageOpenedOnModal?_vm.isMobile?'pt-3':'leading-none pb-3':'',
      {
        'hover:opacity-50 cursor-pointer inline-flex gap-2': _vm.breadcrumb,
        'lg: mx-auto lg:w-main-container gap-3': _vm.registerScreen,
        'px-3':_vm.isMobile,
      }
    ],on:{"click":function($event){_vm.breadcrumb ? _vm.goTo(_vm.breadcrumb) : null}}},[(_vm.breadcrumb)?[_c('base-icon',{attrs:{"width":20,"height":20,"name":"chevronLeft"}})]:_vm._e(),_c('div',{staticClass:"w-full flex flex-col lg:flex-row gap-3 justify-start"},[_vm._t("default")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }